export default function identity(value) {
  return value;
}
